module.exports = function (d3) {
    d3.selection.prototype.first = function() {
        return d3.select(this[0][0]);
    }
    d3.selection.prototype.last = function() {
        last = this.size() - 1;
        return d3.select(this._groups[0][last]);
    }
    d3.selection.prototype.moveToFront = function() {
      return this.each(function(){
        this.parentNode.appendChild(this);
      });
    }
    return;
}
